(function () {
    'use strict';

    angular
            .module('imnApp')
            .controller('AuthorizeOnuController', AuthorizeOnuController);

    AuthorizeOnuController.$inject = ['$scope', '$uibModalInstance', 'OnuData', 'OnuService', 'onuItem', 'BridgeService'];

    function AuthorizeOnuController($scope, $uibModalInstance, OnuData, OnuService, onuItem, BridgeService) {

        var vm = this;

        vm.requestRunning = false;
        vm.postRunning = false;
        vm.configure = false;
        vm.gponSlotList = [];
        vm.modelList = [];
        vm.dataOnu = {
            name: onuItem.serialNumber,
            description: onuItem.description,
            serialNumber: onuItem.serialNumber,
            model: onuItem.model,
            oltName: onuItem.oltName,
            oltIp: onuItem.oltIp,
            oltId: onuItem.oltId,
            sernoId: onuItem.sernoId,
            gponPort: onuItem.gponPort,
            oltMacAddress: onuItem.oltMacAddress,
            gponPortId: onuItem.gponPortId,
            gponSlot: onuItem.gponSlot,
            vendor: onuItem.vendor
        };

        // Request
        vm.requestRunning = true;
        OnuService.getGponSlot(vm.dataOnu.gponPortId).then(successGet).catch(errorGet);

        vm.close = function () {
            if (!vm.postRunning) {
                $uibModalInstance.dismiss('cancel');
            }
        }

        vm.authorize = function (provisioning) {
            if (vm.formAuthorizeOnu.$valid && !vm.postRunning && vm.dataOnu.gponSlot !== '--') {
                vm.dataOnu.name = vm.dataOnu.name.toUpperCase();
                if (vm.dataOnu.description == null) {
                    vm.dataOnu.description = vm.dataOnu.name.toUpperCase();
                }
                vm.postRunning = true;
                OnuService.authorizeOnu(vm.dataOnu).then(successAuthorize).catch(errorAuthorize);
                vm.configure = provisioning;
            }
        }

        // Requests Callbacks
        function successGet(data) {
            vm.requestRunning = false;
            if (data.length === 0 && data) {
                vm.gponSlotList = ['--'];
            } else {
                vm.gponSlotList = data;
            }
            vm.dataOnu.gponSlot = vm.gponSlotList[0];
        }

        function errorGet(response) {
            vm.requestRunning = false;
            OnuService.errorModalConstructor(response, 'get');
            vm.close();
        }

        function successAuthorize(data) {
            var modalInstance;
            vm.postRunning = false;
            if (vm.configure) {
                var bridgeData = {
                    oltId: onuItem.oltId,
                    oltName: onuItem.oltName,
                    gponPort: onuItem.gponPort,
                    onuId: data.id,
                    onuName: data.name,
                    description: data.description
                };
                modalInstance = BridgeService.addBridgeSimpleModalConstructor(bridgeData);
                modalInstance.result.finally(vm.close);
            } else {
                modalInstance = OnuService.successModalConstructor('authorize');
            }
            data.serialNumber = vm.dataOnu.serialNumber;
            OnuData.triggerItemAuthorized(data);

            $uibModalInstance.closed.then(function () {
                OnuData.triggerItemAuthorizedWithStatus(data);
            });
        }

        function errorAuthorize(response) {
            vm.postRunning = false;
            OnuService.errorModalConstructor(response, 'authorize');
        }

        function initialize() {
            if (vm.dataOnu.model === '') {
                OnuService.getModelList().then(successGetModelList).catch(errorGet);
            }
        }

        initialize();

        function successGetModelList(data) {
            vm.requestRunning = false;
            if (data.length === 0 && data) {
                vm.modelList = ['--'];
            } else {
                vm.modelList = data;
            }
        }

    }

})();